import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';

export const SOFTWARE_FEE_REPORT_REQUEST = 'SOFTWARE_FEE_REPORT_REQUEST';
export const SOFTWARE_FEE_REPORT_SUCCESS = 'SOFTWARE_FEE_REPORT_SUCCESS';
export const SOFTWARE_FEE_REPORT_FAILURE = 'SOFTWARE_FEE_REPORT_FAILURE';

export const SOFTWARE_FEE_REPORT_EXPORT_REQUEST = 'SOFTWARE_FEE_REPORT_EXPORT_REQUEST';
export const SOFTWARE_FEE_REPORT_EXPORT_SUCCESS = 'SOFTWARE_FEE_REPORT_EXPORT_SUCCESS';
export const SOFTWARE_FEE_REPORT_EXPORT_FAILURE = 'SOFTWARE_FEE_REPORT_EXPORT_FAILURE';

export const loadSoftwareFeeReport = (options) => ({
	[CALL_API]: {
		types: [SOFTWARE_FEE_REPORT_REQUEST, SOFTWARE_FEE_REPORT_SUCCESS, SOFTWARE_FEE_REPORT_FAILURE],
		endpoint: `api/reports/softwareFee`,
		request: options,
		schema: Schemas.SOFTWARE_FEE_REPORT_ARRAY
	}
});

export const exportSoftwareFeeReport = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [SOFTWARE_FEE_REPORT_EXPORT_REQUEST, SOFTWARE_FEE_REPORT_EXPORT_SUCCESS, SOFTWARE_FEE_REPORT_EXPORT_FAILURE],
			endpoint: `api/reports/softwareFee/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `SoftwareFeeReport-${options.month}-${options.year}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}